<template>
    <app-modal-view :fullwidth-header="true" @close="$emit('close')">
        <template #header>
            <section class="hero is-medium has-background">
                <img :src="community.image.url" alt class="hero-background" />
                <div class="hero-body">
                    <!--p
            aria-label="close"
            class="lb-modal-close has-text-white"
            @click="$emit('close')"
          >
            <span class="icon is-large">
              <i class="mdi mdi-close mdi-24px"></i>
            </span>
                    </p-->
                </div>
            </section>
        </template>
        <template #body>
            <div class="lb-project-modal-content">
                <p class="title has-text-centered is-size-5">{{ community.title }}</p>
                <p class="has-text-centered is-size-6">{{ community.description }}</p>
                <div v-if="isLoggedIn && !isAnonymous" class="columns is-centered pt-4">
                    <div class="column is-6 is-12-mobile">
                        <div class="control has-icons-left lb-join-input">
                            <input
                                v-model="code"
                                :placeholder="
                                    $t('Community.access_code_placeholder')
                                "
                                class="input is-medium is-uppercase title is-size-3"
                                type="text"
                            />
                            <span class="icon is-left is-small is-size-4 has-text-black pt-5">
                                <i class="fas fa-key" aria-hidden="true" />
                            </span>
                            <div v-if="joinError" class="px-3 pt-4">
                                <p
                                    v-t="'Community.join_error'"
                                    class="title has-text-centered is-6"
                                ></p>
                            </div>
                            <button
                                classs="{
                  'is-loading': joiningSession,
                  'is-danger': joinError,
                }"
                                class="button is-primary my-2"
                                @click="joinCommunity"
                            >{{ $t('Community.join').toUpperCase() }}</button>
                        </div>
                    </div>
                </div>
                <section v-else class="section">
                    <p v-t="'Community.login_required'" class="title has-text-centered is-size-5"></p>
                    <div class="buttons is-centered">
                        <button
                            v-t="'log_in'"
                            class="lb-button is-primary"
                            @click="$store.dispatch('requestLoginForm')"
                        ></button>
                    </div>
                </section>
            </div>
        </template>
        <template #footer>
            <!--<figure
                v-if="community.partner"
                class="image lb-community-partner-image"
            >
                <img
                    :alt="community.partner.name"
                    :src="community.partner.image.url"
                    loading="lazy"
                />
            </figure>-->
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import { joinCommunity } from '@/services/API';
export default {
    components: {
        AppModalView,
    },
    props: {
        community: {
            type: Object,
            default() {
                return {};
            },
            required: true,
        },
    },
    data: function () {
        return {
            code: null,
            joinError: false,
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        isAnonymous() {
            return this.$store.getters.isAnonymous;
        },
    },
    methods: {
        async joinCommunity() {
            this.joinError = false;
            const result = await joinCommunity(
                this.community._id,
                this.code
            ).catch(() => {
                this.joinError = true;
            });
            if (!this.joinError) {
                this.$router
                    .push({
                        name: 'community',
                        params: { communityId: this.community._id },
                    })
                    .catch((err) => {
                        // Ignore the vuex err regarding  navigating to the page they are already on.
                        if (
                            err.name !== 'NavigationDuplicated' &&
                            !err.message.includes(
                                'Avoided redundant navigation to current location'
                            )
                        ) {
                            // But print any other errors to the console
                            console.log(err);
                        } else {
                            this.$router.go(); // refresh view
                        }
                    });
            }
        },
    },
};
</script>

<style scoped lang="sass">
.hero
    &.has-background
        position: relative
        overflow: hidden
    &-background
        position: absolute
        object-fit: cover
        object-position: center center
        width: 100%
        height: 100%
    &.is-transparent
        opacity: 0.3
</style>
<style scoped>
.lb-join-input input {
    height: 2em;
}
.lb-join-input button {
    width: 100%;
}
.lb-text-underline {
    text-decoration: underline;
}
</style>
<style scoped>
.hero-body {
    z-index: 1;
}
.lb-community-partner-image {
    bottom: 1rem;
    left: 1rem;
    max-width: 200px;
}
</style>
